module.exports = __webpack_public_path__ + "img/virtual_sports.1840c447.png";